export const RECRUITING_NEXT_ACTIONS = "rpo:recruiting-next-actions";

export function publishRecruitingNextActions(payload) {
  if (!Array.isArray(payload?.recruiting_next_actions) || !payload.recruiting_next_actions.length) return;
  window.dispatchEvent(new CustomEvent(RECRUITING_NEXT_ACTIONS, { detail: payload.recruiting_next_actions }));
}
